"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderCatalogPreviewModal = exports.CatalogPreviewModal = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var react_i18next_1 = require("react-i18next");
var CatalogPreviewModal_module_scss_1 = __importDefault(require("./CatalogPreviewModal.module.scss"));
var Modal_1 = __importDefault(require("react-bootstrap/Modal"));
var CatalogPreview_1 = __importDefault(require("./CatalogPreview"));
var UseCatalogItemListener_1 = require("./UseCatalogItemListener");
var CatalogPreviewModal = function (props) {
    var _a = __read(react_1.useState(false), 2), open = _a[0], setOpen = _a[1];
    var catalog = UseCatalogItemListener_1.useCatalogItemListener().catalog;
    var t = react_i18next_1.useTranslation(['catalog']).t;
    var onModalClose = function () {
        setOpen(false);
    };
    react_1.useEffect(function () {
        if (catalog) {
            setOpen(true);
        }
    }, [catalog]);
    return (react_1.default.createElement(Modal_1.default, { show: open, onHide: onModalClose, className: "modal-catalog-preview fade", dialogClassName: CatalogPreviewModal_module_scss_1.default.CatalogPreviewModal, size: 'lg', centered: true },
        react_1.default.createElement(Modal_1.default.Header, { closeButton: true },
            react_1.default.createElement(Modal_1.default.Title, null, t('catalog.preview.title'))),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement(CatalogPreview_1.default, { catalog: catalog })),
        react_1.default.createElement(Modal_1.default.Footer, { className: "justify-content-center" },
            react_1.default.createElement("button", { type: "button", onClick: onModalClose, className: "btn btn-outline-primary", "data-dismiss": "modal", "aria-label": "Close" }, t('close')))));
};
exports.CatalogPreviewModal = CatalogPreviewModal;
var renderCatalogPreviewModal = function () {
    var modalId = 'aperza-catalog-preview-modal';
    var modal = document.getElementById(modalId);
    if (!modal) {
        var aperzaCatalogPreviewModal = document.createElement('div');
        aperzaCatalogPreviewModal.id = modalId;
        document.body.appendChild(aperzaCatalogPreviewModal);
        react_dom_1.default.render(react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement("div", null) },
            react_1.default.createElement(exports.CatalogPreviewModal, null)), aperzaCatalogPreviewModal);
    }
    else {
        console.warn("Trying to create additional modal: " + modalId);
    }
};
exports.renderCatalogPreviewModal = renderCatalogPreviewModal;
